export const configMetarTafDh = {
  "data": {
    "Type": "GeoJSON",
    "url": "%metartaf_api_url%/metar-taf/aviation_weather/latest?content=%content%&provider=%provider%&user=%customer%&group=%airport_group%&interval=9",
    "cache_busting": true,
    "retain": true,
    "update_interval": 60
  }
};

export const configMetarTafLayerMetar = {
  "Name": "METAR",
  "Renderer": "GeoJSONExt",
  "Attributes": {
    "features": [
      {
        "selector": {
          "type": "key_value",
          "key": "wind_speed_kt_color",
          "value": "violet"
        },
        "style": {
          "default": {
            "type": "point",
            "point_size": 16,
            "sensor_size": 16,
            "line_color": "#000000",
            "point_color": "#723057"
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "wind_speed_kt_color",
          "value": "red_blink"
        },
        "style": {
          "default": {
            "type": "point",
            "point_size": 16,
            "sensor_size": 16,
            "line_color": "#000000",
            "point_color": "#ff0000"
          }
        }
      },
      {
        "selector": {
          "type": "key_value",
          "key": "wind_speed_kt_color",
          "value": "yellow"
        },
        "style": {
          "default": {
            "type": "point",
            "point_size": 16,
            "sensor_size": 16,
            "line_color": "#000000",
            "point_color": "#ffff22"
          }
        }
      },
      {
        "style": {
          "default": {
            "type": "point",
            "point_size": 16,
            "sensor_size": 16,
            "line_color": "#000000",
            "point_color": {
              "property": "metar_color_code"
            }
          }
        }
      }
    ]
  }
};

export const configMetarTafLayerTaf = {
  "Name": "TAF",
  "Renderer": "GeoJSONExt",
  "Attributes": {
    "features": [
      {
        "style": {
          "default": {
            "type": "point",
            "point_size": 10,
            "sensor_size": 16,
            "line_color": "#000000",
            "point_color": {
              "property": "taf_color_code"
            }
          }
        }
      }
    ]
  }
};
